import CustomButton from "../atoms/custom-button.atom";
import CustomText from "../atoms/custom-text.atom";
import { FaCheck, FaTimes, FaArrowRight } from 'react-icons/fa';
import PropTypes from 'prop-types';

const StepFormTemplate = ({ 
    title, 
    description, 
    currentStep, 
    totalSteps, 
    submitEnabled = false,
    onSubmit,
    onClose,
    children
}) => {
    return (
        <div style={styles.container}>
            <div style={styles.closeIconContainer}>
                <FaTimes 
                    onClick={onClose} 
                    style={styles.closeIcon}
                />
            </div>
            <div style={styles.headercontainer}>
                <CustomText variant="headline2xl">{title}</CustomText>
                <CustomText variant="bodySmall" style={{color: '#626262'}}>{`Paso ${currentStep} de ${totalSteps}`}</CustomText>
                <CustomText variant="body">{description}</CustomText>
            </div>
            <div style={styles.contentContainer}>
                {children}
            </div>
            <div style={{display: 'flex', flexGrow: 1}}/>
            <CustomButton 
                variant="yellow" 
                disabled={!submitEnabled}
                onClick={onSubmit}
                right={() => currentStep === totalSteps ? <FaCheck /> : <FaArrowRight />}
            >
                {currentStep === totalSteps ? 'Solicitar' : 'Siguiente'}
            </CustomButton>
        </div>
    )
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%',
        minHeight: 'inherit',
        height: 'inherit',
        boxSizing: 'border-box',
        padding: '24px 16px 16px 16px'
    },
    headercontainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
    },
    closeIconContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: '8px'
    },
    contentContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        margin: '16px 0px'
    },
    closeIcon: {
        cursor: 'pointer',
        fontSize: '24px',
        color: '#1A1A1A'
    }
};

StepFormTemplate.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    currentStep: PropTypes.number.isRequired,
    totalSteps: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    submitEnabled: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
};

export default StepFormTemplate;